import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText.js';

/**
 * Title class.
 */
export default class Title extends withIntersectionObserver(Base, {
  threshold: 0.8,
}) {
  isVisible = false;
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Title',
  };

  /**
   *
   */
  mounted() {
    this.split = SplitText.create(this.$el, {
      type: 'lines',
      mask: 'lines',
      linesClass: 'translate-y-full',
    });
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   *
   */
  launchAnimation() {
    gsap.set(this.$el, { opacity: 1 });
    gsap.to(this.split.lines, {
      y: 0,
      duration: 0.8,
      ease: 'power4.out',
      onStart: () => {
        this.$terminate();
      },
    });
  }
}
